module.exports = __webpack_public_path__ + "static/img/list.25651f1c.svg";